import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ag_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("ag_token"))
      .finally(() => setLoading(false));
  }, []);

  const authenticate = (token, userData) => {
    localStorage.setItem("ag_token", token);
    setUser(userData);
  };

  const updateUser = (patch) => setUser((u) => ({ ...u, ...patch }));

  const logout = () => {
    localStorage.removeItem("ag_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, authenticate, updateUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
